/* Collection card buy box (test variant, 2026-10-26).
   One listener for the page. A tier tap or a Subscribe toggle re-reads the pre-rendered data attributes
   (both one-time and subscription prices are printed by Liquid), so no price is computed here.
   The add itself is the theme's own <product-form> submit, unchanged. ASCII only. */
(function () {
  if (window.__dbCardBuyboxInit) return;
  window.__dbCardBuyboxInit = true;

  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
  function show(el, on) { if (el) el.style.display = on ? '' : 'none'; }

  function update(card) {
    var root = card.querySelector('[data-card-buybox-root]');
    if (!root) return;
    var radios = root.querySelectorAll('input[type="radio"]');
    var sub = root.querySelector('[data-bb-sub]');
    var subOn = !!(sub && sub.checked);
    var threshold = parseInt(card.getAttribute('data-gift-threshold') || '0', 10) || 0;
    var checked = null;

    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var row = r.closest('.variant-option, .bbx-tier');
      var hasPlan = !!r.getAttribute('data-selling-plan-id');
      var mode = subOn && hasPlan;
      if (r.checked) checked = r;
      if (row) {
        row.classList.toggle('selected', r.checked);
        setText(row.querySelector('[data-bb-each]'), mode ? r.getAttribute('data-selling-plan-eachitem-price') : r.getAttribute('data-eachitem-price'));
        var saving = mode ? r.getAttribute('data-selling-plan-saving-price') : r.getAttribute('data-saving-price');
        var savingEl = row.querySelector('[data-bb-saving]');
        setText(savingEl, saving ? 'Save ' + saving : '');
        show(savingEl, !!saving);
        var cents = parseInt(mode ? r.getAttribute('data-selling-plan-price-cents') : r.getAttribute('data-price-cents'), 10) || 0;
        var strip = row.querySelector('[data-gift-gated]');
        if (strip) {
          var gifted = threshold <= 0 || cents >= threshold;
          show(strip, gifted);
          strip.hidden = !gifted;
        }
        /* Sheet tiers: total, struck list total, Save X% */
        var total = row.querySelector('[data-bb-total]');
        if (total) {
          setText(total, mode ? r.getAttribute('data-selling-plan-price') : r.getAttribute('data-price'));
          var was = row.querySelector('[data-bb-total-was]');
          var wasTxt = mode ? r.getAttribute('data-selling-plan-compare-price') : r.getAttribute('data-compare-price');
          if (was) { setText(was, wasTxt || ''); was.hidden = !wasTxt; }
          var pctEl = row.querySelector('[data-bb-pct]');
          var pct = parseInt(mode ? r.getAttribute('data-selling-plan-pct') : r.getAttribute('data-pct'), 10) || 0;
          if (pctEl) { setText(pctEl.querySelector('.bbx-pill__txt') || pctEl, 'Save ' + pct + '%'); pctEl.hidden = pct <= 0; }
        }
      }
    }
    if (!checked) return;

    var hasPlanSel = !!checked.getAttribute('data-selling-plan-id');
    var modeSel = subOn && hasPlanSel;
    var idInput = root.querySelector('[data-bb-id]');
    var planInput = root.querySelector('[data-bb-plan]');
    if (idInput) idInput.value = checked.value;
    if (planInput) {
      planInput.value = checked.getAttribute('data-selling-plan-id') || '';
      planInput.disabled = !modeSel;
    }
    var trim = root.classList.contains('card-buybox--sheet');
    function btnMoney(t) { return t; }
    /* PDP button in the sheet: other scripts rewrite this button's text (loading state, price sync), so rebuild its
       label from the chosen tier each time instead of trusting the price spans to still be there */
    var wrap = root.querySelector('.bb-pdp-atc');
    var pdpBtn = wrap && wrap.querySelector('button');
    if (pdpBtn && !pdpBtn.disabled && !pdpBtn.getAttribute('aria-busy') && !pdpBtn.classList.contains('db-atc-busy')) {
      var pNow = btnMoney(modeSel ? checked.getAttribute('data-selling-plan-price') : checked.getAttribute('data-price'));
      var cNow = btnMoney(modeSel ? checked.getAttribute('data-selling-plan-compare-price') : checked.getAttribute('data-compare-price'));
      var html = wrap.getAttribute('data-bb-label') + ' | <sale-price class="' + (cNow ? 'not-text-on-sale' : 'text-subdued') + '" data-bb-atc-price>' + pNow + '</sale-price>' +
        (cNow ? ' <compare-at-price class="atc-was-price" data-bb-atc-compare>' + cNow + '</compare-at-price>' : '');
      if (pdpBtn.innerHTML !== html) pdpBtn.innerHTML = html;
    }
    setText(root.querySelector('[data-bb-atc-price]'), btnMoney(modeSel ? checked.getAttribute('data-selling-plan-price') : checked.getAttribute('data-price')));
    var cmp = modeSel ? checked.getAttribute('data-selling-plan-compare-price') : checked.getAttribute('data-compare-price');
    var cmpEl = root.querySelector('[data-bb-atc-compare]');
    setText(cmpEl, btnMoney(cmp) || '');
    show(cmpEl, !!cmp);

    /* Free gift strip above the options: on while the chosen tier's own gift line shows (it earns the gift) */
    var gh = root.querySelector('[data-bb-gift-head]');
    if (gh) {
      var selRow = checked.closest('.variant-option, .bbx-tier');
      var selGift = selRow && selRow.querySelector('[data-gift-gated]');
      gh.classList.toggle('is-on', !!(selGift && !selGift.hidden && selGift.style.display !== 'none'));
    }

    /* Segmented Subscribe / One-time control and the delivery line under it */
    var setBtns = root.querySelectorAll('[data-bb-set-sub]');
    for (var j = 0; j < setBtns.length; j++) {
      setBtns[j].setAttribute('aria-checked', (setBtns[j].getAttribute('data-bb-set-sub') === '1') === subOn ? 'true' : 'false');
    }
    /* Sheet auto-refill box: ticked state, interval from the chosen tier's plan, on/off-only parts */
    var box = root.querySelector('[data-bb-box]');
    if (box) box.classList.toggle('is-on', subOn);
    var interval = (checked.getAttribute('data-plan-interval') || '').replace(/^\s+|\s+$/g, '');
    var ivEls = root.querySelectorAll('[data-bb-interval]');
    for (var k = 0; k < ivEls.length; k++) setText(ivEls[k], interval);
    var onOnly = root.querySelectorAll('[data-bb-on-only]');
    for (var k2 = 0; k2 < onOnly.length; k2++) onOnly[k2].hidden = !subOn;
    var offOnly = root.querySelectorAll('[data-bb-off-only]');
    for (var k3 = 0; k3 < offOnly.length; k3++) offOnly[k3].hidden = subOn;

    var note = root.querySelector('[data-bb-plan-note]');
    if (note) {
      var planName = (checked.getAttribute('data-plan-name') || '').replace(/^\s+|\s+$/g, '');
      var suffix = note.getAttribute('data-suffix') || '';
      setText(note, planName + (suffix ? '. ' + suffix : ''));
      note.hidden = !(modeSel && planName);
    }

    var label = root.querySelector('[data-bb-sub-label]');
    if (label) {
      var tpl = card.getAttribute('data-sub-label') || '';
      var extra = checked.getAttribute('data-plan-extra-label') || '';
      if (tpl.indexOf('[amount]') > -1) setText(label, tpl.replace('[amount]', extra));
    }
  }

  /* Sheet mode: the card's button opens the picker; X, the scrim, Esc or a successful add close it */
  function root(card) { return card ? card.__bbRoot || card.querySelector('[data-card-buybox-root]') : null; }
  /* Cards are size containers (container-type), which makes them the frame for a fixed-position child: the sheet was
     drawn inside the card and clipped by the home carousel. On first open the sheet moves to a host at the end of
     <body> that carries the card's data attributes, so every lookup below (closest('[data-card-buybox]')) still works. */
  function portal(card, r) {
    if (card.__bbRoot || card.hasAttribute('data-bb-portal')) return;
    var host = document.createElement('div');
    host.setAttribute('data-card-buybox', '');
    host.setAttribute('data-bb-portal', '');
    ['data-bb-mode', 'data-gift-threshold', 'data-sub-label'].forEach(function (a) { if (card.hasAttribute(a)) host.setAttribute(a, card.getAttribute(a)); });
    document.body.appendChild(host);
    host.appendChild(r);
    host.__bbRoot = r;
    card.__bbRoot = r;
  }
  function openSheet(card) {
    var r = root(card);
    if (!r || !r.classList.contains('card-buybox--sheet')) return;
    portal(card, r);
    card = r.parentNode;
    card.__bbLast = document.activeElement;
    r.hidden = false;
    r.classList.add('is-open');
    document.documentElement.classList.add('bb-sheet-open');
    update(card);
    /* focus the dialog itself (no ring on a tap); Tab then moves through the sheet */
    var f = r.querySelector('.card-buybox__panel');
    if (f && !f.hasAttribute('tabindex')) f.setAttribute('tabindex', '-1');
    setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closeSheet(card) {
    var r = root(card);
    if (!r || !r.classList.contains('is-open')) return;
    r.classList.remove('is-open');
    r.hidden = true;
    if (!document.querySelector('[data-card-buybox-root].is-open')) document.documentElement.classList.remove('bb-sheet-open');
    var back = card.__bbLast;
    if (back && back.focus) { try { back.focus({ preventScroll: true }); } catch (e) {} }
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var o = t.closest('[data-bb-open]');
    if (o) { e.preventDefault(); openSheet(o.closest('[data-card-buybox]')); return; }
    var c = t.closest('[data-bb-close]');
    if (c) { e.preventDefault(); closeSheet(c.closest('[data-card-buybox]')); return; }
    var it = t.closest('[data-bb-info-trigger]');
    if (it) { e.preventDefault(); var tip = it.parentNode.querySelector('[data-bb-info-tooltip]'); if (tip) tip.classList.toggle('is-visible'); return; }
    var ic = t.closest('[data-bb-info-close]');
    if (ic) { e.preventDefault(); var tip2 = ic.closest('[data-bb-info-tooltip]'); if (tip2) tip2.classList.remove('is-visible'); return; }
    var m = t.closest('[data-bb-set-sub]');
    if (m) {
      var mcard = m.closest('[data-card-buybox]');
      var box = mcard && mcard.querySelector('[data-bb-sub]');
      if (box) { box.checked = m.getAttribute('data-bb-set-sub') === '1'; update(mcard); }
    }
  });
  /* Keep keyboard focus inside the open sheet */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var open = document.querySelector('[data-card-buybox-root].is-open .card-buybox__panel');
    if (!open) return;
    var f = open.querySelectorAll('button:not([disabled]), input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]), a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-card-buybox-root].is-open');
    if (open) closeSheet(open.closest('[data-card-buybox]'));
  });
  /* the theme fires variant:add on the form after a successful add; the cart drawer then opens */
  /* Rebuy's cart drawer opens on its own after an add (no theme event): close the sheet the moment it shows */
  function closeOpenSheet() {
    var open = document.querySelector('[data-card-buybox-root].is-open');
    if (open) closeSheet(open.closest('[data-card-buybox]'));
  }
  ['rebuy:smartcart.show', 'rebuy:cart.add', 'rebuy:cart.change'].forEach(function (ev) { document.addEventListener(ev, closeOpenSheet); });
  if (window.MutationObserver) {
    var watchRebuy = function () {
      var rc = document.getElementById('rebuy-cart');
      if (!rc) return false;
      new MutationObserver(function () { if (rc.classList.contains('is-visible')) closeOpenSheet(); })
        .observe(rc, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
      return true;
    };
    if (!watchRebuy()) {
      var tries = 0, t = setInterval(function () { if (watchRebuy() || ++tries > 40) clearInterval(t); }, 500);
    }
  }

  /* any cart change (the theme fires cart:change after an add) closes an open sheet so the cart drawer is in view */
  document.addEventListener('cart:change', function () {
    var open = document.querySelector('[data-card-buybox-root].is-open');
    if (open) closeSheet(open.closest('[data-card-buybox]'));
  });
  document.addEventListener('variant:add', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('[data-card-buybox]') : null;
    if (card) closeSheet(card);
  });

  /* Safari: another script handles taps on option rows and ticks the radio without a change event, so also update
     right after any tap on a row (and on 'input', for keyboard) */
  document.addEventListener('click', function (e) {
    var row = e.target && e.target.closest ? e.target.closest('[data-card-buybox] .card-buybox__options .variant-option, [data-card-buybox] .bbx-tier, [data-card-buybox] .card-buybox__sub, [data-card-buybox] .bbx-sub') : null;
    if (!row) return;
    var card = row.closest('[data-card-buybox]');
    setTimeout(function () { update(card); }, 0);
    setTimeout(function () { update(card); }, 60);
  });
  document.addEventListener('input', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('[data-card-buybox]') : null;
    if (card && e.target.matches('input[type="radio"], [data-bb-sub]')) update(card);
  });

  document.addEventListener('change', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('[data-card-buybox]') : null;
    if (!card) return;
    if (e.target.matches('input[type="radio"], [data-bb-sub]')) update(card);
  });

  /* Phones: drag the sheet down to close it (only when its content is scrolled to the top) */
  var drag = null;
  document.addEventListener('touchstart', function (e) {
    var panel = e.target.closest && e.target.closest('.card-buybox--sheet.is-open .card-buybox__panel');
    if (!panel || panel.scrollTop > 0 || window.innerWidth >= 1000) return;
    drag = { panel: panel, y: e.touches[0].clientY, dy: 0 };
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!drag) return;
    drag.dy = Math.max(0, e.touches[0].clientY - drag.y);
    if (drag.dy > 0) { drag.panel.style.transition = 'none'; drag.panel.style.transform = 'translateY(' + drag.dy + 'px)'; }
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (!drag) return;
    var d = drag; drag = null;
    d.panel.style.transition = ''; d.panel.style.transform = '';
    if (d.dy > 90) closeSheet(d.panel.closest('[data-card-buybox]'));
  });

  /* The cart script covers the button while it adds (db-atc-busy) and restores its old label afterwards; refresh the
     label from the chosen tier as soon as that cover goes, so a tier changed meanwhile shows its own price */
  if (window.MutationObserver) {
    var btns = document.querySelectorAll('[data-card-buybox] .bb-pdp-atc button');
    for (var bi = 0; bi < btns.length; bi++) {
      (function (btn) {
        var wasBusy = false;
        new MutationObserver(function () {
          var busy = btn.classList.contains('db-atc-busy');
          if (wasBusy && !busy) update(btn.closest('[data-card-buybox]'));
          wasBusy = busy;
        }).observe(btn, { attributes: true, attributeFilter: ['class'] });
      })(btns[bi]);
    }
  }

  /* A tap that came before this script ran was held by the guard in product-card.liquid: open that sheet now */
  if (window.__bbPending) {
    var pend = window.__bbPending.closest('[data-card-buybox]');
    window.__bbPending.style.opacity = '';
    window.__bbPending = null;
    if (pend) openSheet(pend);
  }

  /* Back-forward cache can restore a changed selection: re-sync once on show */
  window.addEventListener('pageshow', function () {
    var cards = document.querySelectorAll('[data-card-buybox]');
    for (var i = 0; i < cards.length; i++) update(cards[i]);
  });
})();
